import axios from 'axios';

import { Dialog, Toast } from 'vant'

// import router from "../../router";

// import Global from '@/Global';

import { utilsCleanUserInfo, utilsLogInAgain, utilsMaintainJump } from '@/utils/utils'

const service = axios.create({
    timeout: 60000
})

service.interceptors.request.use(config => {
    // if (config.method == 'post') {
    //     config.data = QS.stringify(config.data);
    // }
    return config
}, error => {
    return Promise.reject(error)
})

service.defaults.withCredentials = true;

service.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';

service.interceptors.response.use(
    response => {
        if (response.data.code == 200) {
            return response.data
        }
        else if (response.data.code == 401) {
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '请求异常',
            });
            Toast.clear();
            Dialog.alert({
                title: '提示',
                message: '登录超时，请重新登录',
            }).then(() => {
                utilsCleanUserInfo();
                utilsLogInAgain();
            });
        }
        else if (response.data.code == 407) {
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '请求异常',
            });
            Toast.clear();
            Dialog.alert({
                title: '提示',
                message: '用户信息不存在,请重新登录',
            }).then(() => {
                utilsCleanUserInfo();
                utilsLogInAgain();
            });
        }
        else if (response.data.code == 503) {
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '请求异常',
            });
            Toast.clear();
            Dialog.alert({
                title: '提示',
                message: '系统维护中',
            }).then(() => {
                utilsCleanUserInfo();
                utilsMaintainJump();
            });
        }
        else {
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '请求异常',
            });
            Toast.clear();
            return response.data
        }
    },
    error => {
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '请求异常',
        });
        Toast.clear();
        if (error.message.includes('timeout')) {
            Dialog.alert({
                title: '提示',
                message: '本次请求超时',
            }).then(() => {

            });
        }
        if (error.response.data.code == 401) {
            Dialog.alert({
                title: '提示',
                message: '登录超时，请重新登录',
            }).then(() => {
                utilsCleanUserInfo();
                utilsLogInAgain();
            });
            return Promise.reject(error.data);
        }
        else if (error.response.data.code == 503) {
            Dialog.alert({
                title: '提示',
                message: '系统维护中',
            }).then(() => {
                utilsCleanUserInfo();
                utilsMaintainJump();
            });
            return Promise.reject(error.data);
        }
        else {
            Dialog.alert({
                title: '异常提示',
                message: JSON.stringify(error.response.data),
            }).then(() => {

            });
            return Promise.reject(error.response.data);
        }
    }
);

export default service
